import React from 'react';

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const socialLinks = [
    { 
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
        </svg>
      ),
      href: 'https://wa.me/918929550611', 
      color: 'hover:bg-green-500',
      label: 'WhatsApp'
    },
    { 
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
        </svg>
      ),
      href: 'https://www.instagram.com/travelrmania_/', 
      color: 'hover:bg-pink-500',
      label: 'Instagram'
    },
    { 
      icon: (
        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
        </svg>
      ),
      href: 'https://www.facebook.com/profile.php?id=61563630987321', 
      color: 'hover:bg-blue-600',
      label: 'Facebook'
    }
  ];

  const quickLinks = [
    { href: '#about', label: 'About Us' },
    { href: '#packages', label: 'Tour Packages' },
    { href: '#destinations', label: 'Destinations' },
    { href: '#testimonials', label: 'Testimonials' },
    { href: '#contact', label: 'Contact' }
  ];

  const tourPackages = [
    { href: '#packages', label: 'Himachal Tours' },
    { href: '#packages', label: 'Rajasthan Tours' },
    { href: '#packages', label: 'Kashmir Tours' },
    { href: '#packages', label: 'Leh Ladakh Tours' },
    { href: '#packages', label: 'Goa Beach Tours' },
    { href: '#packages', label: 'Kerala Backwaters' }
  ];

  return (
    <footer className="bg-gradient-to-br from-sky-100 via-blue-100 to-cyan-100 text-gray-900 relative overflow-hidden">
      {/* Animated Background Orbs */}
      <div className="absolute inset-0 opacity-30">
        <div className="absolute top-10 left-10 w-64 h-64 bg-sky-300 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-10 right-10 w-64 h-64 bg-cyan-300 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }} />
      </div>

      <div className="relative z-10 py-12 sm:py-16 px-4 sm:px-6 md:px-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12">
            
            {/* Brand Section */}
            <div className="lg:col-span-1">
              <div className="flex items-center gap-3 mb-4">
                <img 
                  src="/travelrmania.png" 
                  alt="Travelrmania Logo" 
                  className="w-12 h-12 rounded-full ring-2 ring-cyan-500"
                />
                <h3 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-sky-500 via-blue-600 to-cyan-500">
                  Travelrmania
                </h3>
              </div>
              <p className="text-sm text-gray-600 leading-relaxed mb-6">
                Your trusted travel partner in New Delhi. We create unforgettable journeys 
                with customized tour packages and premium travel experiences across India.
              </p>
              
              {/* Social Links */}
              <div className="flex flex-wrap gap-3">
                {socialLinks.map((social, i) => (
                  <a
                    key={i}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`w-10 h-10 bg-white border border-sky-200 rounded-full flex items-center justify-center text-gray-600 transition-all duration-300 ${social.color} hover:text-white hover:scale-110 hover:shadow-lg`}
                    title={social.label}
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-lg font-semibold mb-6 text-gray-900 flex items-center gap-2">
                <span className="w-1 h-6 bg-gradient-to-b from-sky-500 to-cyan-500 rounded-full" />
                Quick Links
              </h4>
              <ul className="space-y-3">
                {quickLinks.map((link, i) => (
                  <li key={i}>
                    <a
                      href={link.href}
                      className="text-sm text-gray-600 hover:text-cyan-600 hover:translate-x-2 transition-all duration-300 flex items-center group"
                    >
                      <span className="w-2 h-2 bg-sky-500 rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Tour Packages */}
            <div>
              <h4 className="text-lg font-semibold mb-6 text-gray-900 flex items-center gap-2">
                <span className="w-1 h-6 bg-gradient-to-b from-cyan-500 to-blue-500 rounded-full" />
                Popular Tours
              </h4>
              <ul className="space-y-3">
                {tourPackages.map((link, i) => (
                  <li key={i}>
                    <a
                      href={link.href}
                      className="text-sm text-gray-600 hover:text-sky-600 hover:translate-x-2 transition-all duration-300 flex items-center group"
                    >
                      <span className="w-2 h-2 bg-cyan-500 rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="text-lg font-semibold mb-6 text-gray-900 flex items-center gap-2">
                <span className="w-1 h-6 bg-gradient-to-b from-sky-500 to-cyan-500 rounded-full" />
                Contact Us
              </h4>
              <div className="space-y-4">
                <div className="flex items-start gap-3 text-sm text-gray-600">
                  <svg className="w-5 h-5 text-cyan-600 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                  </svg>
                  <span>New Delhi, India</span>
                </div>
                
                <a
                  href="tel:+918929550611"
                  className="flex items-center gap-3 text-sm text-gray-600 hover:text-sky-600 transition-colors group"
                >
                  <svg className="w-5 h-5 text-sky-600 group-hover:scale-110 transition-transform" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                  </svg>
                  <span>+91 89295 50611</span>
                </a>
                
                <a
                  href="mailto:travelrmania@gmail.com"
                  className="flex items-center gap-3 text-sm text-gray-600 hover:text-cyan-600 transition-colors group"
                >
                  <svg className="w-5 h-5 text-cyan-600 group-hover:scale-110 transition-transform" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                  </svg>
                  <span>travelrmania@gmail.com</span>
                </a>

                <div className="flex items-center gap-3 text-sm">
                  <svg className="w-5 h-5 text-sky-600" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                  </svg>
                  <span className="font-semibold text-cyan-600">24/7 Available</span>
                </div>

                <a
                  href="https://wa.me/918929550611"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 mt-2 px-4 py-2 bg-gradient-to-r from-green-500 to-green-600 text-white rounded-lg hover:from-green-600 hover:to-green-700 transition-all duration-300 hover:scale-105 shadow-lg"
                >
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                  </svg>
                  WhatsApp Us
                </a>
              </div>
            </div>
          </div>

          {/* Bottom Section */}
          <div className="mt-12 pt-8 border-t border-sky-200 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-gray-600 text-center sm:text-left">
              &copy; {new Date().getFullYear()} Travelrmania. All rights reserved. Made with ❤️ for travelers.
            </p>

            {/* Back to Top Button */}
            <button
              onClick={scrollToTop}
              className="w-10 h-10 bg-gradient-to-r from-sky-500 to-cyan-500 rounded-full flex items-center justify-center text-white shadow-lg hover:shadow-2xl hover:scale-110 transition-all duration-300"
              aria-label="Back to top"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
              </svg>
            </button>
          </div>

          {/* Trust Badges */}
          <div className="mt-8 flex flex-wrap justify-center gap-4 text-xs text-gray-600">
            <span className="flex items-center gap-1 px-3 py-1 bg-white border border-sky-200 rounded-full hover:shadow-md transition-shadow">
              <svg className="w-4 h-4 text-sky-600" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              Best Price Guarantee
            </span>
            <span className="flex items-center gap-1 px-3 py-1 bg-white border border-sky-200 rounded-full hover:shadow-md transition-shadow">
              <svg className="w-4 h-4 text-cyan-600" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              Secure Booking
            </span>
            <span className="flex items-center gap-1 px-3 py-1 bg-white border border-sky-200 rounded-full hover:shadow-md transition-shadow">
              <svg className="w-4 h-4 text-sky-600" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
              </svg>
              5.0 Rating
            </span>
            <span className="flex items-center gap-1 px-3 py-1 bg-white border border-sky-200 rounded-full hover:shadow-md transition-shadow">
              <svg className="w-4 h-4 text-cyan-600" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd" />
              </svg>
              Professional Service
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}

// import React from 'react';

// export default function Footer() {
//   const scrollToTop = () => {
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//   };

//   const socialLinks = [
//     { 
//       icon: (
//         <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//           <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
//         </svg>
//       ),
//       href: 'https://wa.me/918929550611', 
//       color: 'hover:bg-green-500',
//       label: 'WhatsApp'
//     },
//     { 
//       icon: (
//         <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//           <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
//         </svg>
//       ),
//       href: 'https://instagram.com/travelrmania', 
//       color: 'hover:bg-pink-500',
//       label: 'Instagram'
//     },
//     { 
//       icon: (
//         <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//           <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84"/>
//         </svg>
//       ),
//       href: 'https://facebook.com/travelrmania', 
//       color: 'hover:bg-blue-600',
//       label: 'Facebook'
//     },
//     { 
//       icon: (
//         <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//           <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
//         </svg>
//       ),
//       href: 'https://youtube.com/@travelrmania', 
//       color: 'hover:bg-red-500',
//       label: 'YouTube'
//     }
//   ];

//   const quickLinks = [
//     { href: '#about', label: 'About Us' },
//     { href: '#packages', label: 'Tour Packages' },
//     { href: '#destinations', label: 'Destinations' },
//     { href: '#testimonials', label: 'Testimonials' },
//     { href: '#contact', label: 'Contact' }
//   ];

//   const tourPackages = [
//     { href: '#packages', label: 'Himachal Tours' },
//     { href: '#packages', label: 'Rajasthan Tours' },
//     { href: '#packages', label: 'Kashmir Tours' },
//     { href: '#packages', label: 'Leh Ladakh Tours' },
//     { href: '#packages', label: 'Goa Beach Tours' },
//     { href: '#packages', label: 'Kerala Backwaters' }
//   ];

//   return (
//     <footer className="bg-gradient-to-br from-sky-100 via-blue-100 to-cyan-100 text-gray-900 relative overflow-hidden">
//       {/* Animated Background Orbs */}
//       <div className="absolute inset-0 opacity-30">
//         <div className="absolute top-10 left-10 w-64 h-64 bg-sky-300 rounded-full blur-3xl animate-pulse" />
//         <div className="absolute bottom-10 right-10 w-64 h-64 bg-cyan-300 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }} />
//       </div>

//       <div className="relative z-10 py-12 sm:py-16 px-4 sm:px-6 md:px-16">
//         <div className="max-w-6xl mx-auto">
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12">
            
//             {/* Brand Section */}
//             <div className="lg:col-span-1">
//               <div className="flex items-center gap-3 mb-4">
//                 <img 
//                   src="/travelrmania.png" 
//                   alt="Travelrmania Logo" 
//                   className="w-12 h-12 rounded-full ring-2 ring-cyan-500"
//                 />
//                 <h3 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-sky-500 via-blue-600 to-cyan-500">
//                   Travelrmania
//                 </h3>
//               </div>
//               <p className="text-sm text-gray-600 leading-relaxed mb-6">
//                 Your trusted travel partner in New Delhi. We create unforgettable journeys 
//                 with customized tour packages and premium travel experiences across India.
//               </p>
              
//               {/* Social Links */}
//               <div className="flex flex-wrap gap-3">
//                 {socialLinks.map((social, i) => (
//                   <a
//                     key={i}
//                     href={social.href}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className={`w-10 h-10 bg-white border border-sky-200 rounded-full flex items-center justify-center text-gray-600 transition-all duration-300 ${social.color} hover:text-white hover:scale-110 hover:shadow-lg`}
//                     title={social.label}
//                   >
//                     {social.icon}
//                   </a>
//                 ))}
//               </div>
//             </div>

//             {/* Quick Links */}
//             <div>
//               <h4 className="text-lg font-semibold mb-6 text-gray-900 flex items-center gap-2">
//                 <span className="w-1 h-6 bg-gradient-to-b from-sky-500 to-cyan-500 rounded-full" />
//                 Quick Links
//               </h4>
//               <ul className="space-y-3">
//                 {quickLinks.map((link, i) => (
//                   <li key={i}>
//                     <a
//                       href={link.href}
//                       className="text-sm text-gray-600 hover:text-cyan-600 hover:translate-x-2 transition-all duration-300 flex items-center group"
//                     >
//                       <span className="w-2 h-2 bg-sky-500 rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
//                       {link.label}
//                     </a>
//                   </li>
//                 ))}
//               </ul>
//             </div>

//             {/* Tour Packages */}
//             <div>
//               <h4 className="text-lg font-semibold mb-6 text-gray-900 flex items-center gap-2">
//                 <span className="w-1 h-6 bg-gradient-to-b from-cyan-500 to-blue-500 rounded-full" />
//                 Popular Tours
//               </h4>
//               <ul className="space-y-3">
//                 {tourPackages.map((link, i) => (
//                   <li key={i}>
//                     <a
//                       href={link.href}
//                       className="text-sm text-gray-600 hover:text-sky-600 hover:translate-x-2 transition-all duration-300 flex items-center group"
//                     >
//                       <span className="w-2 h-2 bg-cyan-500 rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
//                       {link.label}
//                     </a>
//                   </li>
//                 ))}
//               </ul>
//             </div>

//             {/* Contact Info */}
//             <div>
//               <h4 className="text-lg font-semibold mb-6 text-gray-900 flex items-center gap-2">
//                 <span className="w-1 h-6 bg-gradient-to-b from-sky-500 to-cyan-500 rounded-full" />
//                 Contact Us
//               </h4>
//               <div className="space-y-4">
//                 <div className="flex items-start gap-3 text-sm text-gray-600">
//                   <svg className="w-5 h-5 text-cyan-600 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
//                     <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
//                   </svg>
//                   <span>New Delhi, India</span>
//                 </div>
                
//                 <a
//                   href="tel:+918929550611"
//                   className="flex items-center gap-3 text-sm text-gray-600 hover:text-sky-600 transition-colors group"
//                 >
//                   <svg className="w-5 h-5 text-sky-600 group-hover:scale-110 transition-transform" fill="currentColor" viewBox="0 0 20 20">
//                     <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
//                   </svg>
//                   <span>+91-89295-50611</span>
//                 </a>
                
//                 <a
//                   href="mailto:jagdish0000singh@gmail.com"
//                   className="flex items-center gap-3 text-sm text-gray-600 hover:text-cyan-600 transition-colors group"
//                 >
//                   <svg className="w-5 h-5 text-cyan-600 group-hover:scale-110 transition-transform" fill="currentColor" viewBox="0 0 20 20">
//                     <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
//                     <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
//                   </svg>
//                   <span>jagdish0000singh@gmail.com</span>
//                 </a>

//                 <div className="flex items-center gap-3 text-sm">
//                   <svg className="w-5 h-5 text-sky-600" fill="currentColor" viewBox="0 0 20 20">
//                     <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
//                   </svg>
//                   <span className="font-semibold text-cyan-600">24/7 Available</span>
//                 </div>

//                 <a
//                   href="https://wa.me/918929550611"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="inline-flex items-center gap-2 mt-2 px-4 py-2 bg-gradient-to-r from-green-500 to-green-600 text-white rounded-lg hover:from-green-600 hover:to-green-700 transition-all duration-300 hover:scale-105 shadow-lg"
//                 >
//                   <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//                     <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
//                   </svg>
//                   WhatsApp Us
//                 </a>
//               </div>
//             </div>
//           </div>

//           {/* Bottom Section */}
//           <div className="mt-12 pt-8 border-t border-sky-200 flex flex-col sm:flex-row items-center justify-between gap-4">
//             <p className="text-sm text-gray-600 text-center sm:text-left">
//               &copy; {new Date().getFullYear()} Travelrmania. All rights reserved. Made with ❤️ for travelers.
//             </p>

//             {/* Back to Top Button */}
//             <button
//               onClick={scrollToTop}
//               className="w-10 h-10 bg-gradient-to-r from-sky-500 to-cyan-500 rounded-full flex items-center justify-center text-white shadow-lg hover:shadow-2xl hover:scale-110 transition-all duration-300"
//               aria-label="Back to top"
//             >
//               <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
//               </svg>
//             </button>
//           </div>

//           {/* Trust Badges */}
//           <div className="mt-8 flex flex-wrap justify-center gap-4 text-xs text-gray-600">
//             <span className="flex items-center gap-1 px-3 py-1 bg-white border border-sky-200 rounded-full hover:shadow-md transition-shadow">
//               <svg className="w-4 h-4 text-sky-600" fill="currentColor" viewBox="0 0 20 20">
//                 <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
//               </svg>
//               Best Price Guarantee
//             </span>
//             <span className="flex items-center gap-1 px-3 py-1 bg-white border border-sky-200 rounded-full hover:shadow-md transition-shadow">
//               <svg className="w-4 h-4 text-cyan-600" fill="currentColor" viewBox="0 0 20 20">
//                 <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
//               </svg>
//               Secure Booking
//             </span>
//             <span className="flex items-center gap-1 px-3 py-1 bg-white border border-sky-200 rounded-full hover:shadow-md transition-shadow">
//               <svg className="w-4 h-4 text-sky-600" fill="currentColor" viewBox="0 0 20 20">
//                 <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
//               </svg>
//               5.0 Rating
//             </span>
//             <span className="flex items-center gap-1 px-3 py-1 bg-white border border-sky-200 rounded-full hover:shadow-md transition-shadow">
//               <svg className="w-4 h-4 text-cyan-600" fill="currentColor" viewBox="0 0 20 20">
//                 <path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd" />
//               </svg>
//               Professional Service
//             </span>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// }

// import React from 'react';

// export default function Footer() {
//   const scrollToTop = () => {
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//   };

//   const socialLinks = [
//     { 
//       icon: (
//         <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//           <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
//         </svg>
//       ),
//       href: 'https://wa.me/918929550611', 
//       color: 'hover:bg-green-500',
//       label: 'WhatsApp'
//     },
//     { 
//       icon: (
//         <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//           <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
//         </svg>
//       ),
//       href: 'https://instagram.com/travelrmania', 
//       color: 'hover:bg-pink-500',
//       label: 'Instagram'
//     },
//     { 
//       icon: (
//         <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//           <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84"/>
//         </svg>
//       ),
//       href: 'https://facebook.com/travelrmania', 
//       color: 'hover:bg-blue-600',
//       label: 'Facebook'
//     },
//     { 
//       icon: (
//         <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//           <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
//         </svg>
//       ),
//       href: 'https://youtube.com/@travelrmania', 
//       color: 'hover:bg-red-500',
//       label: 'YouTube'
//     }
//   ];

//   const quickLinks = [
//     { href: '#about', label: 'About Us' },
//     { href: '#packages', label: 'Tour Packages' },
//     { href: '#destinations', label: 'Destinations' },
//     { href: '#testimonials', label: 'Testimonials' },
//     { href: '#contact', label: 'Contact' }
//   ];

//   const tourPackages = [
//     { href: '#packages', label: 'Himachal Tours' },
//     { href: '#packages', label: 'Rajasthan Tours' },
//     { href: '#packages', label: 'Kashmir Tours' },
//     { href: '#packages', label: 'Leh Ladakh Tours' },
//     { href: '#packages', label: 'Goa Beach Tours' },
//     { href: '#packages', label: 'Kerala Backwaters' }
//   ];

//   return (
//     <footer className="bg-gradient-to-br from-gray-900 via-black to-gray-900 text-white relative overflow-hidden">
//       {/* Animated Background Orbs */}
//       <div className="absolute inset-0 opacity-20">
//         <div className="absolute top-10 left-10 w-64 h-64 bg-blue-500 rounded-full blur-3xl animate-pulse" />
//         <div className="absolute bottom-10 right-10 w-64 h-64 bg-orange-500 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }} />
//       </div>

//       <div className="relative z-10 py-12 sm:py-16 px-4 sm:px-6 md:px-16">
//         <div className="max-w-6xl mx-auto">
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12">
            
//             {/* Brand Section */}
//             <div className="lg:col-span-1">
//               <div className="flex items-center gap-3 mb-4">
//                 <img 
//                   src="/travelrmania.png" 
//                   alt="Travelrmania Logo" 
//                   className="w-12 h-12 rounded-full ring-2 ring-orange-500"
//                 />
//                 <h3 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 via-blue-300 to-orange-400">
//                   Travelrmania
//                 </h3>
//               </div>
//               <p className="text-sm text-gray-300 leading-relaxed mb-6">
//                 Your trusted travel partner in New Delhi. We create unforgettable journeys 
//                 with customized tour packages and premium travel experiences across India.
//               </p>
              
//               {/* Social Links */}
//               <div className="flex flex-wrap gap-3">
//                 {socialLinks.map((social, i) => (
//                   <a
//                     key={i}
//                     href={social.href}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className={`w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center text-gray-300 transition-all duration-300 ${social.color} hover:scale-110 hover:shadow-lg`}
//                     title={social.label}
//                   >
//                     {social.icon}
//                   </a>
//                 ))}
//               </div>
//             </div>

//             {/* Quick Links */}
//             <div>
//               <h4 className="text-lg font-semibold mb-6 text-white flex items-center gap-2">
//                 <span className="w-1 h-6 bg-gradient-to-b from-blue-500 to-orange-500 rounded-full" />
//                 Quick Links
//               </h4>
//               <ul className="space-y-3">
//                 {quickLinks.map((link, i) => (
//                   <li key={i}>
//                     <a
//                       href={link.href}
//                       className="text-sm text-gray-300 hover:text-orange-400 hover:translate-x-2 transition-all duration-300 flex items-center group"
//                     >
//                       <span className="w-2 h-2 bg-blue-500 rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
//                       {link.label}
//                     </a>
//                   </li>
//                 ))}
//               </ul>
//             </div>

//             {/* Tour Packages */}
//             <div>
//               <h4 className="text-lg font-semibold mb-6 text-white flex items-center gap-2">
//                 <span className="w-1 h-6 bg-gradient-to-b from-orange-500 to-blue-500 rounded-full" />
//                 Popular Tours
//               </h4>
//               <ul className="space-y-3">
//                 {tourPackages.map((link, i) => (
//                   <li key={i}>
//                     <a
//                       href={link.href}
//                       className="text-sm text-gray-300 hover:text-blue-400 hover:translate-x-2 transition-all duration-300 flex items-center group"
//                     >
//                       <span className="w-2 h-2 bg-orange-500 rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
//                       {link.label}
//                     </a>
//                   </li>
//                 ))}
//               </ul>
//             </div>

//             {/* Contact Info */}
//             <div>
//               <h4 className="text-lg font-semibold mb-6 text-white flex items-center gap-2">
//                 <span className="w-1 h-6 bg-gradient-to-b from-blue-500 to-orange-500 rounded-full" />
//                 Contact Us
//               </h4>
//               <div className="space-y-4">
//                 <div className="flex items-start gap-3 text-sm text-gray-300">
//                   <svg className="w-5 h-5 text-orange-400 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
//                     <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
//                   </svg>
//                   <span>New Delhi, India</span>
//                 </div>
                
//                 <a
//                   href="tel:+918929550611"
//                   className="flex items-center gap-3 text-sm text-gray-300 hover:text-blue-400 transition-colors group"
//                 >
//                   <svg className="w-5 h-5 text-blue-400 group-hover:scale-110 transition-transform" fill="currentColor" viewBox="0 0 20 20">
//                     <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
//                   </svg>
//                   <span>+91-89295-50611</span>
//                 </a>
                
//                 <a
//                   href="mailto:jagdish0000singh@gmail.com"
//                   className="flex items-center gap-3 text-sm text-gray-300 hover:text-orange-400 transition-colors group"
//                 >
//                   <svg className="w-5 h-5 text-orange-400 group-hover:scale-110 transition-transform" fill="currentColor" viewBox="0 0 20 20">
//                     <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
//                     <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
//                   </svg>
//                   <span>jagdish0000singh@gmail.com</span>
//                 </a>

//                 <div className="flex items-center gap-3 text-sm">
//                   <svg className="w-5 h-5 text-blue-400" fill="currentColor" viewBox="0 0 20 20">
//                     <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
//                   </svg>
//                   <span className="font-semibold text-orange-400">24/7 Available</span>
//                 </div>

//                 <a
//                   href="https://wa.me/918929550611"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="inline-flex items-center gap-2 mt-2 px-4 py-2 bg-gradient-to-r from-green-500 to-green-600 text-white rounded-lg hover:from-green-600 hover:to-green-700 transition-all duration-300 hover:scale-105 shadow-lg"
//                 >
//                   <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//                     <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
//                   </svg>
//                   WhatsApp Us
//                 </a>
//               </div>
//             </div>
//           </div>

//           {/* Bottom Section */}
//           <div className="mt-12 pt-8 border-t border-gray-800 flex flex-col sm:flex-row items-center justify-between gap-4">
//             <p className="text-sm text-gray-400 text-center sm:text-left">
//               &copy; {new Date().getFullYear()} Travelrmania. All rights reserved. Made with ❤️ for travelers.
//             </p>

//             {/* Back to Top Button */}
//             <button
//               onClick={scrollToTop}
//               className="w-10 h-10 bg-gradient-to-r from-blue-500 to-orange-500 rounded-full flex items-center justify-center text-white shadow-lg hover:shadow-2xl hover:scale-110 transition-all duration-300"
//               aria-label="Back to top"
//             >
//               <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
//               </svg>
//             </button>
//           </div>

//           {/* Trust Badges */}
//           <div className="mt-8 flex flex-wrap justify-center gap-4 text-xs text-gray-400">
//             <span className="flex items-center gap-1 px-3 py-1 bg-gray-800 rounded-full">
//               <svg className="w-4 h-4 text-blue-400" fill="currentColor" viewBox="0 0 20 20">
//                 <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
//               </svg>
//               Best Price Guarantee
//             </span>
//             <span className="flex items-center gap-1 px-3 py-1 bg-gray-800 rounded-full">
//               <svg className="w-4 h-4 text-orange-400" fill="currentColor" viewBox="0 0 20 20">
//                 <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
//               </svg>
//               Secure Booking
//             </span>
//             <span className="flex items-center gap-1 px-3 py-1 bg-gray-800 rounded-full">
//               <svg className="w-4 h-4 text-blue-400" fill="currentColor" viewBox="0 0 20 20">
//                 <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
//               </svg>
//               5.0 Rating
//             </span>
//             <span className="flex items-center gap-1 px-3 py-1 bg-gray-800 rounded-full">
//               <svg className="w-4 h-4 text-orange-400" fill="currentColor" viewBox="0 0 20 20">
//                 <path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd" />
//               </svg>
//               Professional Service
//             </span>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// }


// import React from 'react';

// export default function Footer() {
//   const scrollToTop = () => {
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//   };

//   const socialLinks = [
//     { 
//       icon: (
//         <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//           <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
//         </svg>
//       ),
//       href: 'https://wa.me/917027005176', 
//       color: 'hover:bg-green-500',
//       label: 'WhatsApp'
//     },
//     { 
//       icon: (
//         <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//           <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
//         </svg>
//       ),
//       href: 'https://twitter.com/dreamtotravels', 
//       color: 'hover:bg-blue-400',
//       label: 'Twitter'
//     },
//     { 
//       icon: (
//         <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//           <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
//         </svg>
//       ),
//       href: 'https://instagram.com/dreamtotravels', 
//       color: 'hover:bg-pink-500',
//       label: 'Instagram'
//     },
//     { 
//       icon: (
//         <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//           <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
//         </svg>
//       ),
//       href: 'https://youtube.com/@dreamtotravels', 
//       color: 'hover:bg-red-500',
//       label: 'YouTube'
//     },
//     { 
//       icon: (
//         <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
//           <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84"/>
//         </svg>
//       ),
//       href: 'https://facebook.com/dreamtotravels', 
//       color: 'hover:bg-blue-600',
//       label: 'Facebook'
//     }
//   ];

//   const quickLinks = [
//     { href: '#about', label: 'About Us' },
//     { href: '#packages', label: 'Tour Packages' },
//     { href: '#vehicles', label: 'Our Fleet' },
//     { href: '#destinations', label: 'Destinations' },
//     { href: '#testimonials', label: 'Testimonials' },
//     { href: '#contact', label: 'Contact' }
//   ];

//   const tourPackages = [
//     { href: '#packages', label: 'Golden Triangle Tour' },
//     { href: '#packages', label: 'Himachal Tours' },
//     { href: '#packages', label: 'Rajasthan Tours' },
//     { href: '#packages', label: 'Kashmir Tours' },
//     { href: '#packages', label: 'Leh Ladakh Tours' },
//     { href: '#packages', label: 'Honeymoon Packages' }
//   ];

//   return (
//     <footer className="bg-gray-900 text-white relative overflow-hidden">
//       {/* Animated Background */}
//       <div className="absolute inset-0 opacity-10">
//         <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-blue-600 via-purple-600 to-pink-600" />
//       </div>

//       <div className="relative z-10 py-12 sm:py-16 px-4 sm:px-6 md:px-16">
//         <div className="max-w-6xl mx-auto">
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12">
            
//             {/* Brand Section */}
//             <div className="lg:col-span-1">
//               <div className="flex items-center gap-3 mb-4">
//                 <div className="bg-white p-3 rounded-full">
//   <svg
//     className="w-8 h-8 text-blue-600"
//     fill="none"
//     stroke="currentColor"
//     strokeWidth="2"
//     viewBox="0 0 24 24"
//   >
//     <path
//       strokeLinecap="round"
//       strokeLinejoin="round"
//       d="M10.5 21l3-7.5L21 10.5l-7.5-3L10.5 0 9 7.5 1.5 10.5l7.5 3L10.5 21z"
//     />
//   </svg>
//                 </div>
//                 <h3 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500">
//                   Dream to Travels
//                 </h3>
//               </div>
//               <p className="text-sm text-gray-300 leading-relaxed mb-6">
//                 Your trusted travel partner in Delhi. We specialize in luxury tempo travellers, 
//                 customized tour packages, and unforgettable travel experiences across India.
//               </p>
              
//               {/* Social Links */}
//               <div className="flex flex-wrap gap-3">
//                 {socialLinks.map((social, i) => (
//                   <a
//                     key={i}
//                     href={social.href}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className={`w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center text-gray-300 transition-all duration-300 ${social.color} hover:scale-110`}
//                     title={social.label}
//                   >
//                     {social.icon}
//                   </a>
//                 ))}
//               </div>
//             </div>

//             {/* Quick Links */}
//             <div>
//               <h4 className="text-lg font-semibold mb-6 text-white">Quick Links</h4>
//               <ul className="space-y-3">
//                 {quickLinks.map((link, i) => (
//                   <li key={i}>
//                     <a
//                       href={link.href}
//                       className="text-sm text-gray-300 hover:text-white hover:translate-x-2 transition-all duration-300 flex items-center group"
//                     >
//                       <span className="w-2 h-2 bg-purple-500 rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
//                       {link.label}
//                     </a>
//                   </li>
//                 ))}
//               </ul>
//             </div>

//             {/* Tour Packages */}
//             <div>
//               <h4 className="text-lg font-semibold mb-6 text-white">Popular Tours</h4>
//               <ul className="space-y-3">
//                 {tourPackages.map((link, i) => (
//                   <li key={i}>
//                     <a
//                       href={link.href}
//                       className="text-sm text-gray-300 hover:text-white hover:translate-x-2 transition-all duration-300 flex items-center group"
//                     >
//                       <span className="w-2 h-2 bg-pink-500 rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
//                       {link.label}
//                     </a>
//                   </li>
//                 ))}
//               </ul>
//             </div>

//             {/* Contact Info */}
//             <div>
//               <h4 className="text-lg font-semibold mb-6 text-white">Contact Us</h4>
//               <div className="space-y-4">
//                 <a 
//                   href="https://maps.google.com/?q=A-851,+Camp+no.4,+Jawala+Puri+Delhi+110087"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="flex items-start gap-3 text-sm text-gray-300 hover:text-white transition-colors"
//                 >
//                   <svg className="w-5 h-5 text-blue-400 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
//                     <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
//                   </svg>
//                   <span>A-851, Camp no.4, Jawala Puri Delhi, India 110087</span>
//                 </a>
                
//                 <a
//                   href="tel:+917027005176"
//                   className="flex items-center gap-3 text-sm text-gray-300 hover:text-white transition-colors"
//                 >
//                   <svg className="w-5 h-5 text-green-400" fill="currentColor" viewBox="0 0 20 20">
//                     <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
//                   </svg>
//                   <span>+91-7027005176</span>
//                 </a>
                
//                 <a
//                   href="tel:+917082127844"
//                   className="flex items-center gap-3 text-sm text-gray-300 hover:text-white transition-colors"
//                 >
//                   <svg className="w-5 h-5 text-green-400" fill="currentColor" viewBox="0 0 20 20">
//                     <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
//                   </svg>
//                   <span>+91-7082127844</span>
//                 </a>
                
//                 <a
//                   href="mailto:Dreamtotravels24@gmail.com"
//                   className="flex items-center gap-3 text-sm text-gray-300 hover:text-white transition-colors"
//                 >
//                   <svg className="w-5 h-5 text-purple-400" fill="currentColor" viewBox="0 0 20 20">
//                     <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
//                     <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
//                   </svg>
//                   <span>Dreamtotravels24@gmail.com</span>
//                 </a>

//                 <div className="flex items-center gap-3 text-sm text-gray-300">
//                   <svg className="w-5 h-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
//                     <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
//                   </svg>
//                   <span className="font-semibold">24/7 Available</span>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Bottom Section */}
//           <div className="mt-12 pt-8 border-t border-gray-800 flex flex-col sm:flex-row items-center justify-between gap-4">
//             <p className="text-sm text-gray-400 text-center sm:text-left">
//               &copy; {new Date().getFullYear()} Dream to Travels. All rights reserved. Made with ❤️ for travelers.
//             </p>

//             {/* Back to Top Button */}
//             <button
//               onClick={scrollToTop}
//               className="w-10 h-10 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center text-white shadow-lg hover:shadow-2xl hover:scale-110 transition-all duration-300"
//               aria-label="Back to top"
//             >
//               <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
//               </svg>
//             </button>
//           </div>

//           {/* Trust Badges */}
//           <div className="mt-8 flex flex-wrap justify-center gap-4 text-xs text-gray-500">
//             <span className="flex items-center gap-1">
//               <svg className="w-4 h-4 text-green-400" fill="currentColor" viewBox="0 0 20 20">
//                 <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
//               </svg>
//               Best Price Guarantee
//             </span>
//             <span className="flex items-center gap-1">
//               <svg className="w-4 h-4 text-blue-400" fill="currentColor" viewBox="0 0 20 20">
//                 <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
//               </svg>
//               Secure Booking
//             </span>
//             <span className="flex items-center gap-1">
//               <svg className="w-4 h-4 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
//                 <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
//               </svg>
//               5.0 Rating
//             </span>
//             <span className="flex items-center gap-1">
//               <svg className="w-4 h-4 text-red-400" fill="currentColor" viewBox="0 0 20 20">
//                 <path fillRule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clipRule="evenodd" />
//               </svg>
//               Sanitized Vehicles
//             </span>
//           </div>
//         </div>
//       </div>
//     </footer>
//   );
// }

// import React from 'react';
// import { motion } from 'framer-motion';
// import {
//   FaLinkedin,
//   FaEnvelope,
//   FaYoutube,
//   FaInstagram,
//   FaGithub,
//   FaHeart,
//   FaArrowUp
// } from 'react-icons/fa';

// export default function Footer() {
//   const scrollToTop = () => {
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//   };

//   const socialLinks = [
//     { icon: FaLinkedin, href: 'https://www.linkedin.com/in/jagdish-singh-092919244/', color: 'hover:text-blue-500' },
//     { icon: FaGithub, href: 'https://github.com/jagdish97897', color: 'hover:text-gray-400' },
//     { icon: FaYoutube, href: 'https://www.youtube.com/@Sadabahar-iu2rr', color: 'hover:text-red-500' },
//     { icon: FaInstagram, href: 'https://www.instagram.com/ig_mrnatwarlal234', color: 'hover:text-pink-500' },
//     { icon: FaEnvelope, href: 'mailto:jagdish0000singh@gmail.com', color: 'hover:text-green-500' }
//   ];

//   const quickLinks = [
//     { href: '#about', label: 'About' },
//     { href: '#skills', label: 'Skills' },
//     { href: '#projects', label: 'Projects' },
//     { href: '#experience', label: 'Experience' },
//     { href: '#youtube', label: 'Videos' },
//     { href: '#contact', label: 'Contact' }
//   ];

//   return (
//     <footer className="bg-gray-900 text-white relative overflow-hidden">
//       {/* Animated Background */}
//       <motion.div
//         className="absolute inset-0 opacity-10"
//         initial={{ opacity: 0 }}
//         whileInView={{ opacity: 0.1 }}
//         transition={{ duration: 2 }}
//       >
//         <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-blue-600 via-purple-600 to-pink-600" />
//       </motion.div>

//       <div className="relative z-10 py-12 sm:py-16 px-4 sm:px-6 md:px-16">
//         <div className="max-w-6xl mx-auto">
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12">
            
//             {/* Brand Section */}
//             <motion.div
//               initial={{ opacity: 0, y: 30 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.6 }}
//               viewport={{ once: true }}
//               className="lg:col-span-2"
//             >
//               <motion.h3 
//                 className="text-2xl sm:text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 via-purple-500 to-pink-500 mb-4"
//                 whileHover={{ scale: 1.05 }}
//               >
//                 Jagdish Singh
//               </motion.h3>
//               <p className="text-sm sm:text-base text-gray-300 leading-relaxed mb-6 max-w-md">
//                 Full Stack Developer passionate about creating innovative digital solutions. 
//                 Transforming ideas into reality through clean code and modern technologies.
//               </p>
              
//               {/* Social Links */}
//               <div className="flex flex-wrap gap-4">
//                 {socialLinks.map((social, i) => (
//                   <motion.a
//                     key={i}
//                     href={social.href}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className={`w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center text-gray-300 transition-all duration-300 ${social.color}`}
//                     whileHover={{ 
//                       scale: 1.2, 
//                       rotateY: 180,
//                       boxShadow: "0 10px 25px rgba(0,0,0,0.3)"
//                     }}
//                     whileTap={{ scale: 0.9 }}
//                     initial={{ opacity: 0, y: 20 }}
//                     whileInView={{ opacity: 1, y: 0 }}
//                     transition={{ delay: i * 0.1, duration: 0.3 }}
//                     viewport={{ once: true }}
//                   >
//                     <social.icon className="text-lg" />
//                   </motion.a>
//                 ))}
//               </div>
//             </motion.div>

//             {/* Quick Links */}
//             <motion.div
//               initial={{ opacity: 0, y: 30 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.6, delay: 0.2 }}
//               viewport={{ once: true }}
//             >
//               <h4 className="text-lg font-semibold mb-6 text-white">Quick Links</h4>
//               <ul className="space-y-3">
//                 {quickLinks.map((link, i) => (
//                   <motion.li 
//                     key={i}
//                     initial={{ opacity: 0, x: -20 }}
//                     whileInView={{ opacity: 1, x: 0 }}
//                     transition={{ delay: i * 0.1, duration: 0.3 }}
//                     viewport={{ once: true }}
//                   >
//                     <motion.a
//                       href={link.href}
//                       className="text-sm text-gray-300 hover:text-white transition-all duration-300 flex items-center group"
//                       whileHover={{ x: 5 }}
//                     >
//                       <span className="w-2 h-2 bg-purple-500 rounded-full mr-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
//                       {link.label}
//                     </motion.a>
//                   </motion.li>
//                 ))}
//               </ul>
//             </motion.div>

//             {/* Contact Info */}
//             <motion.div
//               initial={{ opacity: 0, y: 30 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.6, delay: 0.4 }}
//               viewport={{ once: true }}
//             >
//               <h4 className="text-lg font-semibold mb-6 text-white">Get In Touch</h4>
//               <div className="space-y-4">
//                 <motion.div 
//                   className="flex items-center gap-3 text-sm text-gray-300"
//                   whileHover={{ x: 5, color: "#ffffff" }}
//                 >
//                   <FaEnvelope className="text-blue-400" />
//                   <span>jagdish0000singh@gmail.com</span>
//                 </motion.div>
//                 <motion.div 
//                   className="flex items-center gap-3 text-sm text-gray-300"
//                   whileHover={{ x: 5, color: "#ffffff" }}
//                 >
//                   <FaLinkedin className="text-blue-400" />
//                   <span>LinkedIn Profile</span>
//                 </motion.div>
//                 <motion.div 
//                   className="flex items-center gap-3 text-sm text-gray-300"
//                   whileHover={{ x: 5, color: "#ffffff" }}
//                 >
//                   <FaYoutube className="text-red-400" />
//                   <span>YouTube Channel</span>
//                 </motion.div>
//               </div>
//             </motion.div>
//           </div>

//           {/* Bottom Section */}
//           <motion.div
//             initial={{ opacity: 0 }}
//             whileInView={{ opacity: 1 }}
//             transition={{ duration: 0.6, delay: 0.6 }}
//             viewport={{ once: true }}
//             className="mt-12 pt-8 border-t border-gray-800 flex flex-col sm:flex-row items-center justify-between gap-4"
//           >
//             <motion.p 
//               className="text-sm text-gray-400 flex items-center gap-2"
//               whileHover={{ scale: 1.05 }}
//             >
//               &copy; {new Date().getFullYear()} Jagdish Singh. 
//               <motion.span
//                 animate={{ scale: [1, 1.2, 1] }}
//                 transition={{ duration: 1, repeat: Infinity }}
//               >
           
//               </motion.span>
//           Made with ❤️, coffee ☕, and clean code.
//             </motion.p>

//             {/* Back to Top Button */}
//             <motion.button
//               onClick={scrollToTop}
//               className="w-10 h-10 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center text-white shadow-lg hover:shadow-2xl transition-all duration-300"
//               whileHover={{ 
//                 scale: 1.1, 
//                 rotateY: 180,
//                 boxShadow: "0 15px 30px rgba(0,0,0,0.3)"
//               }}
//               whileTap={{ scale: 0.9 }}
//               initial={{ opacity: 0, y: 20 }}
//               whileInView={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.3 }}
//               viewport={{ once: true }}
//             >
//               <FaArrowUp className="text-sm" />
//             </motion.button>
//           </motion.div>
//         </div>
//       </div>
//     </footer>
//   );
// }
